import React from 'react';

import type {IntlShape} from 'react-intl';

import type {ContentShape} from '@edume/magnificent';

import IntlHeading from '../../IntlHeading';

type FileSizeErrorStepArgs = {
  type: 'image' | 'video';
  intl: IntlShape;
  goBack: () => void;
};

const getFileSizeErrorStep = ({type, intl, goBack}: FileSizeErrorStepArgs) =>
  ({
    iconUrl: '/resources/img/38_cross.svg',
    title: intl.formatMessage({id: 'UploadModal.errorTitle'}, {type}),
    body: (
      <IntlHeading
        size='ant'
        textKey={
          type === 'video'
            ? 'UploadModal.videoErrorHint'
            : 'UploadModal.imageErrorHint'
        }
        as='legacy-span'
      />
    ),
    buttons: [
      {
        type: 'primary',
        onClick: goBack,
        text: intl.formatMessage({id: 'Button.goBack'}),
        dataAutomation: 'try-again-button',
      },
    ],
  }) satisfies ContentShape;

export default getFileSizeErrorStep;
